export default function Pencil() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <g clipPath="url(#clip0_1313_67574)">
            <path d="M7.33826 1.69104L1.71875 7.31055L4.69196 10.2838L10.3115 4.66425L7.33826 1.69104Z" fill="#6C3F99"/>
            <path d="M11.8212 2.39148L9.62628 0.16545C9.40834 -0.0524834 9.06588 -0.0524834 8.86351 0.149883C8.86351 0.149883 8.86351 0.149883 8.84794 0.16545L7.88281 1.13058L10.856 4.11938L11.8212 3.15425C12.0391 2.93631 12.0391 2.59385 11.8212 2.39148Z" fill="#6C3F99"/>
            <path d="M1.28238 7.96484L0.052611 11.265C-0.0563556 11.5452 0.0837443 11.8565 0.363944 11.9655C0.488477 12.0122 0.628577 12.0122 0.75311 11.9655L4.05324 10.7201L1.28238 7.96484Z" fill="#6C3F99"/>
            </g>
            <defs>
            <clipPath id="clip0_1313_67574">
            <rect width="12" height="12" fill="white"/>
            </clipPath>
            </defs>
        </svg>
    )
}